import React, { Component } from "react";
import "./App.css";

class MovingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list1: ["item1", "item2", "item3", "item4"],
      list2: ["item5", "item6", "item7", "item8"],
    };
  }

  makeList = () => {
    fetch("status.json")
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        var arr1 = data;
        var arr2 = [];
        var arr3 = [];
        for (var i = 0; i < arr1.length; i++) {
          if (arr1[i].indexOf("start") != -1) {
            arr2.push(arr1[i].split(".")[0]);
          } else arr3.push(arr1[i].split(".")[0]);
        }
        console.log(arr2, arr3);
        this.setState({
          list1: arr2,
          list2: arr3,
        });
      });
  };

  handlelist = (event) => {
    let list1 = this.state.list1;
    let list2 = this.state.list2;

    console.log(list1.includes(event.target.id));

    let index;
    if (list1.includes(event.target.id)) {
      index = list1.indexOf(event.target.id);
      if (index > -1) {
        list1.splice(index, 1);
      }
      list2.push(event.target.id);
    } else if (list2.includes(event.target.id)) {
      index = list2.indexOf(event.target.id);
      if (index > -1) {
        list2.splice(index, 1);
      }
      list1.push(event.target.id);
    }
    this.setState({
      list1: list1,
      list2: list2,
    });
  };

  componentDidMount() {
    this.makeList();
  }

  render() {
    return (
      <div>
        <div>Hello</div>
        <div>
          {this.state.list1.map((k) => (
            <li id={k} onClick={this.handlelist}>
              {k}
            </li>
          ))}
        </div>
        <br />
        <div>
          {this.state.list2.map((k) => (
            <li id={k} onClick={this.handlelist}>
              {k}
            </li>
          ))}
        </div>
      </div>
    );
  }
}
export default MovingList;
